import ajax from '../utils/request';

const robotApi = {

  /***************************机器人配置****************************** */
  // 请求机器人列表
  getRbotList(params) {
    return ajax({
      url: '/robot/conf/list',
      type: 'get',
      params: params
    });
  },
  // 添加机器人配置
  addRbot(params) {
    return ajax({
      url: '/robot/conf/add',
      type: 'post',
      params: params
    });
  },
  // 修改机器人列表
  updateRbot(params) {
    return ajax({
      url: '/robot/conf/update',
      type: 'post',
      params: params
    });
  },
/***************************聊天内容****************************** */
  // 机器人聊天内容列表
  getContentList(params) {
    return ajax({
      url: '/robot/content/list',
      type: 'get',
      params: params
    })
  },
  // 增加聊天内容
  addContent(params) {
    return ajax({
      url: '/robot/content/add',
      type: 'post',
      params: params
    })
  },
  // 删除聊天内容
  delContent(params) {
    return ajax({
      url: '/robot/content/del',
      type: 'delete',
      params: params
    })
  }
};

export default robotApi;
